import React, { useEffect } from 'react';
import LeadersImage from "../../assets/aboutpage/LeadersMessage/leadershipImage.jpeg";
import DirectorImage from "../../assets/aboutpage/LeadersMessage/ellen.jpeg";
import AcademicsImage from "../../assets/aboutpage/LeadersMessage/principalImage.png";
import AdminImage from "../../assets/aboutpage/LeadersMessage/admin.jpg";
import StanleyImage from "../../assets//stanley.jpeg";
import PhinehasImage from "../../assets/phinehas.jpeg";
import JanetImage from "../../assets/janet.jpeg";
import Banner from '../../components/Banner/Banner';
import MessageSection from '../../components/AboutComponents/MessageSection/MessageSection';
import Footer from '../../components/Footer/Footer';
import BannerBar from '../../components/BannerBar/BannerBar';
import { Link, useLocation } from 'react-router-dom';
import { BsWhatsapp } from "react-icons/bs";
import { MdPerson } from 'react-icons/md';

const leaders = [
    {
        image: DirectorImage,
        name: "Ellen Antwiwaa Sarkodie (Mrs.)",
        role: "Managing Director",
        accent: "#021d53",
    },
    {
        image: AdminImage,
        name: "Mr. Eric Opoku Asare",
        role: "HR / Accounts Manager",
        accent: "#021d53",
    },
    {
        image: AcademicsImage,
        name: "Mr. Philips Yeboah Pimpong",
        role: "Head of Academics",
        accent: "#021d53",
    },
    {
        image: StanleyImage,
        name: "Mr. Stanley Asare Prempeh",
        role: "Admission & Exams Officer",
        accent: "#ed3137",
    },
    {
        image: JanetImage,
        name: "Miss. Janet Gyamfi",
        role: "HOD Preschool",
        accent: "#ed3137",
    },
    {
        image: PhinehasImage,
        name: "Mr. Phinehas Agyekum Donkor",
        role: "HOD Elementary School",
        accent: "#ed3137",
    },
];

const LeadersMessage = () => {
    const location = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location]);

    return (
        <div>
            <Banner title="About Us" subtitle="Message From Leadership" image={LeadersImage} />
            <BannerBar />
            <MessageSection />

            {/* Leadership & Management Section */}
            <section className="py-24 px-5 md:px-20 lg:px-40 bg-[#f8f9fa]">
                <div className="max-w-6xl mx-auto">

                    {/* Section Header */}
                    <div className="text-center mb-16">
                        <div className="flex items-center justify-center gap-4 mb-4">
                            <div className="h-1 w-12 bg-[#ed3137] rounded-full"></div>
                            <p className="text-[#ed3137] font-bold uppercase tracking-widest text-sm">Our Team</p>
                            <div className="h-1 w-12 bg-[#ed3137] rounded-full"></div>
                        </div>
                        <h2 className="text-3xl md:text-4xl font-extrabold text-[#021d53]">Leadership &amp; Management</h2>
                        <p className="text-gray-500 mt-3 max-w-xl mx-auto text-sm">
                            Meet the dedicated team of professionals who guide Anell School of Excellence with vision, integrity, and commitment.
                        </p>
                    </div>

                    {/* Cards Grid */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
                        {leaders.map((leader, idx) => (
                            <div
                                key={idx}
                                className="group bg-white rounded overflow-hidden shadow-sm hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 border border-gray-100"
                            >
                                {/* Photo */}
                                <div className="relative h-96 overflow-hidden bg-gray-100">
                                    {leader.image ? (
                                        <img
                                            src={leader.image}
                                            alt={leader.name}
                                            className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                                        />
                                    ) : (
                                        <div className="w-full h-full flex items-center justify-center bg-gradient-to-br from-[#021d53] to-[#0a3580]">
                                            <MdPerson className="text-8xl text-white/30" />
                                        </div>
                                    )}
                                    {/* Color overlay on hover */}
                                    <div
                                        className="absolute inset-0 opacity-0 group-hover:opacity-20 transition-opacity duration-500"
                                        style={{ backgroundColor: leader.accent }}
                                    ></div>
                                </div>

                                {/* Info */}
                                <div className="p-6">
                                    {/* Accent bar */}
                                    <div
                                        className="h-1 w-10 rounded-full mb-4 transition-all duration-500 group-hover:w-full"
                                        style={{ backgroundColor: leader.accent }}
                                    ></div>
                                    <h3 className="text-lg font-bold text-[#221b2d] leading-snug mb-2">{leader.name}</h3>
                                    <span
                                        className="inline-block text-xs font-semibold uppercase tracking-widest px-3 py-1 rounded-full text-white"
                                        style={{ backgroundColor: leader.accent }}
                                    >
                                        {leader.role}
                                    </span>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <Footer />
           
        </div>
    );
};

export default LeadersMessage;
